import { Entity } from '@hglobal/fin-ui';

export interface Team extends Entity<string> {
  orgId: string;
  description: string;
  name: string;
  status: TeamStatus;
  agent: boolean;
  isInternal?: boolean;
  promocode: string;
  exchangeMinAmount: number | null;
  countIssuedCards: number;
  maxCardsPerWallet: number;
  feeProfile: FeeProfile;

  // UI properties
  statusText?: string;
}

interface FeeProfile {
  cardIssuanceAmount: number;
  cardIssuanceFree: number;
}

export enum TeamStatus {
  Active = 'active',
  Blocked = 'blocked',
}
